import { DataTableCol } from "../../../../components/data-table/types";

export const CRMNotesGridCols: DataTableCol[] = [
    {
        title: 'Title',
        control: 'title',
        canShowColumn: true
    },
    {
        title: 'Subject',
        control: 'subject',
        canShowColumn: true
    },
    {
        title: 'Bu Id',
        control: 'bu_id',
        canShowColumn: true
    },
    {
        title: 'user Id',
        control: 'userId',
        canShowColumn: true
    },
    {
        title: 'Status',
        control: 'note_status',
        canShowColumn: true
    },
];